import config from "./WebIMConfig";
import websdk from "easemob-websdk";
import emedia from "easemob-emedia";
import webrtc from "easemob-webrtc";
import store from '@/store';
import { bpoTip2 } from "@/scripts/bpo.js";

function ack(message) {
    var bodyId = message.id; // 需要发送已读回执的消息id
    var msg = new WebIM.message("read", WebIM.conn.getUniqueId());
    msg.set({
        id: bodyId,
        to: message.from
    });
    WebIM.conn.send(msg.body);
}
// 初始化IM SDK
var WebIM = {};
WebIM = window.WebIM = websdk;
WebIM.config = config;
WebIM.conn = new WebIM.connection({
    appKey: WebIM.config.appkey,
    isHttpDNS: WebIM.config.isHttpDNS,
    isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
    https: WebIM.config.https,
    url: WebIM.config.xmppURL,
    apiUrl: WebIM.config.apiURL,
    isAutoLogin: true,
    heartBeatWait: WebIM.config.heartBeatWait,
    autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
    autoReconnectInterval: WebIM.config.autoReconnectInterval,
    isStropheLog: WebIM.config.isStropheLog,
    delivery: WebIM.config.delivery
});
if (!WebIM.conn.apiUrl) {
    WebIM.conn.apiUrl = WebIM.config.apiURL;
}
// 注册监听回调
WebIM.conn.listen({
    onOpened: function(message) { // 连接成功回调
        // 登录或注册成功后 跳转到好友页面
        console.log('>>>>>>>>>>>>>>>>登陆成功<<<<<<<<<<<<<<<<<<<');
        store.commit('setHxLoginStatus', true);
    },
    onClosed: function(message) {
        console.log('>>>>>>>>>>>>>>>>环信关闭<<<<<<<<<<<<<<<<<<<');
        store.commit('setHxLoginId', '');
        store.commit('setHxLoginStatus', false);
    }, // 连接关闭回调
    onTextMessage: function(message) {
        const { from, to, type } = message;
        const chatId = type !== "chat" ? to : from;
        const typeMap = {
            chat: "contact",
            groupchat: "group",
            chatroom: "chatroom"
        };
        console.log('text', message);
        store.commit("updateMsgList", {
            chatType: typeMap[message.type],
            chatId: chatId,
            msg: message.data,
            bySelf: false,
            from: message.from,
            mid: message.id,
            time: Number(message.time),
            ext: message.ext || {},
            type: "text",
        });
        type === 'chat' && ack(message);
        if (WebIM && WebIM.call && message && message.ext && message.ext.msg_extension) {
            var msgExtension = message.ext.msg_extension && JSON.parse(message.ext.msg_extension);
            var options = {
                confrId: message.ext.conferenceId,
                password: message.ext.password || "",
                gid: msgExtension.group_id,
                inviter: msgExtension.inviter
            };
            WebIM.call.listener.onInvite(message.from, options);
        }
    }, // 收到文本消息
    onEmojiMessage: function(message) {
        console.log("onEmojiMessage", message);
        const { type } = message;
        type === 'chat' && ack(message);
    }, // 收到表情消息
    onPictureMessage: function(message) {
        const { from, to, type } = message;
        const chatId = type !== "chat" ? to : from;
        const typeMap = {
            chat: "contact",
            groupchat: "group",
            chatroom: "chatroom"
        };
        store.commit("updateMsgList", {
            chatType: typeMap[message.type],
            chatId: chatId,
            msg: message.url,
            bySelf: false,
            type: "img",
            from: message.from,
            time: Number(message.time)
        });
        type === 'chat' && ack(message);
    }, // 收到图片消息
    onCmdMessage: function(message) {
        console.log("onCmdMessage", message);
    }, // 收到命令消息
    onAudioMessage: function(message) {
        const typeMap = {
            chat: "contact",
            groupchat: "group",
            chatroom: "chatroom"
        };
        const chatId = message.type !== "chat" ? message.to : message.from;
        let options = {
            url: message.url,
            headers: { Accept: "audio/mp3" },
            onFileDownloadComplete: function(response) {
                let objectUrl = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response);
                store.commit("updateMsgList", {
                    chatType: typeMap[message.type],
                    chatId: chatId,
                    msg: objectUrl,
                    bySelf: false,
                    type: "audio",
                    from: message.from,
                    time: Number(message.time)
                });
            },
            onFileDownloadError: function() {
                console.log("音频下载失败");
            }
        };
        WebIM.utils.download.call(WebIM.conn, options);
        message.type === 'chat' && ack(message);
    }, // 收到音频消息
    onLocationMessage: function(message) {
        console.log("onLocationMessage", message);
        message.type === 'chat' && ack(message);
    }, // 收到位置消息
    onFileMessage: function(message) {
        const { from, to, type } = message;
        const chatId = type !== "chat" ? to : from;
        const typeMap = {
            chat: "contact",
            groupchat: "group",
            chatroom: "chatroom"
        };
        store.commit("updateMsgList", {
            chatType: typeMap[message.type],
            chatId: chatId,
            msg: message.url,
            bySelf: false,
            type: "file",
            filename: message.filename,
            file_length: message.file_length,
            from: message.from,
            time: Number(message.time)
        });
        type === 'chat' && ack(message);
    }, // 收到文件消息
    onVideoMessage: function(message) {
        console.log("onVideoMessage", message);
        const { from, to, type } = message;
        const chatId = type !== "chat" ? to : from;
        const typeMap = {
            chat: "contact",
            groupchat: "group",
            chatroom: "chatroom"
        };
        let options = {
            url: message.url,
            headers: {
                Accept: "audio/mp4"
            },
            onFileDownloadComplete: function(response) {
                let objectURL = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response);
                store.commit("updateMsgList", {
                    chatType: typeMap[message.type],
                    chatId: chatId,
                    msg: objectURL,
                    bySelf: false,
                    type: "video",
                    filename: message.filename,
                    file_length: message.file_length,
                    from: message.from,
                    time: Number(message.time)
                });
            },
            onFileDownloadError: function() {
                console.log("视频下载失败");
            }
        };
        WebIM.utils.download.call(WebIM.conn, options);
        type === 'chat' && ack(message);
    }, // 收到视频消息
    onPresence: function(message) {
        console.log("onPresence", message);
        let select_id = store.state.group.groupInfo.gid; // 群组相关操作，更新数据时需要
        switch (message.type) {
            case "subscribe":
                store.commit("changeFriendRequestState", {
                    isShow: true,
                    ...message
                });
                break;
            case "subscribed":
                store.dispatch("onGetContactUserList");
                // bpoTip2(message.from + " " + "已订阅", 2);
                break;
            case "unsubscribed":
                store.dispatch("onGetContactUserList");
                // TODO
                if ("code" in message) {
                    bpoTip2(message.from + " " + "请求被拒绝", 2);
                } else {
                    // bpoTip2(message.from + " " + "已退订", 2);
                }
                break;

            case "direct_joined": // 被拉进群--不需要同意
                store.dispatch("onGetGroupUserList");
                bpoTip2(`${message.from}邀请您加入群：${message.gid}`, 1);
                break;
            case "invite": //收到邀请进群的通知
                store.commit("updateGroupInviteNotifications", {
                    isShow: true,
                    ...message
                });
                break;
            case "joinGroupNotifications": // 收到申请进群的通知
                store.commit("updateGroupNotifications", {
                    isShow: true,
                    ...message
                });
                break;
            case "memberJoinPublicGroupSuccess": // 成员加入聊天室成功回调
                store.dispatch("onGetGroupinfo", { select_id });
                bpoTip2(`${message.from}已加入群组`, 1);
                break;
            case "joinPublicGroupSuccess": //申请加入群组成功回调
                store.dispatch("onGetGroupUserList");
                break;
            case "deleteGroupChat": // 解散群组
                store.dispatch("onGetGroupUserList")
                bpoTip2(`${message.from}将群：${message.gid} 已解散`, 1);
                break
            case "removedFromGroup": //移除
                store.dispatch("onGetGroupUserList")
                bpoTip2("已被" + message.from + "移除群：" + message.gid, 1);
                break;
            case "leaveGroup":
                store.dispatch("onGetGroupinfo", { select_id });
        }
    }, // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
    onRoster: function(message) {
        console.log("onRoster", message);
    }, // 处理好友申请
    onInviteMessage: function(message) {
        console.log("onInviteMessage", message);
    }, // 处理群组邀请
    onOnline: function() {
        console.log("onOnline 网络已连接");
        store.commit('setHxLoginStatus', true);
    }, // 本机网络连接成功
    onOffline: function() {
        store.commit('setHxLoginStatus', false);
        console.log("onOffline 网络已断开");
    }, // 本机网络掉线
    onError: function(message) {
        store.commit('setHxLoginStatus', false);
        if (message.type == 0) {
            console.log('请输入账号密码')
        } else if (message.type == 28) {
            console.log("未登陆")
        } else if (message.type == 16) {
            console.log("连接错误")
        } else if (message.data && message.data.data && JSON.parse(message.data.data).error_description == "user not found") {
            bpoTip2('用户名不存在！', 2);
        } else if (message.data && message.data.data && JSON.parse(message.data.data).error_description == "invalid password") {
            console.log('密码无效！')
        } else if (message.data && message.data.data && JSON.parse(message.data.data).error_description == "user not activated") {
            bpoTip2('用户已被封禁！', 2);
        } else if (message.type == "504") {
            bpoTip2('消息撤回失败', 2);
        }
        // 报错返回到登录页面
        // router.push({ path: '/login' });
    }, // 失败回调
    onRecallMessage: message => {
        console.log("撤回消息", message);
        message.status = "recall";
        message.msg = "对方撤回了一条消息";
        // store.commit("updateMessageStatus", message);
    },
    onBlacklistUpdate: function(list) { // 黑名单变动
        // 查询黑名单，将好友拉黑，将好友从黑名单移除都会回调这个函数，list则是黑名单现有的所有好友信息
        // 更新好友黑名单
        console.log("黑名单变动", list);
        let blackList = list;
        store.commit("updateBlackList", blackList);
    },
    onReceivedMessage: function(message) {
        store.commit("updateMessageMid", message);
        message.status = "sent";
        store.commit("updateMessageStatus", message);
        store.dispatch('getSessionList')
    }, // 收到消息送达服务器回执

    onDeliveredMessage: function(message) {
        console.log("onDeliveredMessage", message);
        store.commit('updateMessageStatus', message)
    }, // 收到消息送达客户端回执

    onReadMessage: function(message) {
        console.log("onReadMessage", message);
        message.status = "read";
        store.commit("updateMessageStatus", message);
    }, // 收到消息已读回执

    onCreateGroup: function(message) {
        console.log("onCreateGroup", message);
        store.dispatch("onGetGroupUserList");
    }, // 创建群组成功回执（需调用createGroupNew）
    onMutedMessage: function(message) {
            console.log("onMutedMessage", message);
        } // 如果用户在A群组被禁言，在A群发消息会走这个回调并且消息不会传递给群其它成员
});
WebIM.Emoji = {
    map: {
        '[):]': 'ee_1.png',
        '[:D]': 'ee_2.png',
        '[;)]': 'ee_3.png',
        '[:-o]': 'ee_4.png',
        '[:p]': 'ee_5.png',
        '[(H)]': 'ee_6.png',
        '[:@]': 'ee_7.png',
        '[:s]': 'ee_8.png',
        '[:$]': 'ee_9.png',
        '[:(]': 'ee_10.png',
        '[:\'(]': 'ee_11.png',
        '[:|]': 'ee_12.png',
        '[(a)]': 'ee_13.png',
        '[8o|]': 'ee_14.png',
        '[|]': 'ee_15.png',
        '[+o(]': 'ee_16.png',
        '[<o)]': 'ee_17.png',
        '[|-)]': 'ee_18.png',
        '[*-)]': 'ee_19.png',
        '[:-#]': 'ee_20.png',
        '[:-*]': 'ee_21.png',
        '[^o)]': 'ee_22.png',
        '[8-)]': 'ee_23.png',
        '[(|)]': 'ee_24.png',
        '[(u)]': 'ee_25.png',
        '[(S)]': 'ee_26.png',
        '[(*)]': 'ee_27.png',
        '[(#)]': 'ee_28.png',
        '[(R)]': 'ee_29.png',
        '[({)]': 'ee_30.png',
        '[(})]': 'ee_31.png',
        '[(k)]': 'ee_32.png',
        '[(F)]': 'ee_33.png',
        '[(W)]': 'ee_34.png',
        '[(D)]': 'ee_35.png'
    },
    get imgs() {
        let arr = [];
        Object.keys(this.map).map((item, index) => {
            arr.push({ path: require('static/faces/ee_' + (index + 1) + '.png') })
        })
        return arr;
    }
};
// WebIM.NewEmoji = {
//     map: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '😍', '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '😵', '🤯', '🤠', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹', '😮', '😯', '😲', '😳', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '😤', '😡', '😠', '🤬', '😈', '👿', '💀', '☠', '💩', '🤡', '👹', '👺', '👻', '👽', '👾', '🤖', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '💋', '👋', '🤚', '🖐', '✋', '🖖', '👌', '✌', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍', '💅', '🤳', '💪', '👂', '👃', '🧠', '👀', '👁', '👅', '👄', '👶', '🧒', '👦', '👧', '🧑', '👱', '👨', '🧔', '👱‍', '👨‍', '👨‍', '👨‍', '👨‍', '👩', '👱‍', '👩‍', '👩‍', '👩‍', '👩‍', '🧓', '👴', '👵', '🙍', '🙍‍', '🙍‍', '🙎', '🙎‍', '🙎‍', '🙅', '🙅‍', '🙅‍', '🙆', '🙆‍', '🙆‍', '💁', '💁‍', '💁‍', '🙋', '🙋‍', '🙋‍', '🙇', '🙇‍', '🙇‍', '🤦', '🤦‍', '🤦‍', '🤷', '🤷‍', '🤷‍', '👨‍⚕️', '👩‍⚕️', '👨‍🎓', '👩‍🎓', '👨‍🏫', '👩‍🏫', '👨‍⚖️', '👩‍⚖️', '👨‍🌾', '👩‍🌾', '👨‍🍳', '👩‍🍳', '👨‍🔧', '👩‍🔧', '👨‍🏭', '👩‍🏭', '👨‍💼', '👩‍💼', '👨‍🔬', '👩‍🔬', '👨‍💻', '👩‍💻', '👨‍🎤', '👩‍🎤', '👨‍🎨', '👩‍🎨', '👨‍✈️', '👩‍✈️', '👨‍🚀', '👩‍🚀', '👨‍🚒', '👩‍🚒', '👮', '👮‍♂️', '👮‍♀️', '🕵Det', '🕵️‍♂️', '🕵️‍♀️', '💂', '💂‍', '💂‍', '👷', '👷‍', '👷‍', '🤴', '👸', '👳', '👳‍', '👳‍', '👲', '🧕', '🤵', '👰', '🤰', '🤱', '👼', '🎅', '🤶', '🧙', '🧙‍', '🧙‍', '🧚', '🧚‍', '🧚‍', '🧛', '🧛‍', '🧛‍', '🧜', '🧜‍', '🧜‍', '🧝', '🧝‍', '🧝‍', '🧞', '🧞‍', '🧞‍', '🧟', '🧟‍', '🧟‍', '💆', '💆‍', '💆‍', '💇', '💇‍', '💇‍', '🚶', '🚶‍', '🚶‍', '🏃', '🏃‍', '🏃‍', '💃', '🕺', '🕴', '👯', '👯‍', '👯‍', '🧖', '🧖‍', '🧖‍', '🧘', '👭', '👫', '👬', '💏', '👨‍', '👩‍', '💑', '👨‍', '👩‍', '👪', '👨‍👩‍👦', '👨‍👩‍👧', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧', '👨‍👨‍👦', '👨‍👨‍👧', '👨‍👨‍👧‍👦', '👨‍👨‍👦‍👦', '👨‍👨‍👧‍👧', '👩‍👩‍👦', '👩‍👩‍👧', '👩‍👩‍👧‍👦', '👩‍👩‍👦‍👦', '👩‍👩‍👧‍👧', '👨‍👦', '👨‍👦‍👦', '👨‍👧', '👨‍👧‍👦', '👨‍👧‍👧', '👩‍👦', '👩‍👦‍👦', '👩‍👧', '👩‍👧‍👦', '👩‍👧‍👧', '🗣', '👤', '👥', '👣', '🌂', '☂', '👓', '🕶', '👔', '👕', '👖', '🧣', '🧤', '🧥', '🧦', '👗', '👘', '👙', '👚', '👛', '👜', '👝', '🎒', '👞', '👟', '👠', '👡', '👢', '👑', '👒', '🎩', '🎓', '🧢', '⛑', '💄', '💍', '💼']
// };
WebIM.WebRTC = webrtc;
WebIM.EMedia = emedia;
export default WebIM;